module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/mojo-e25f0765a4d12662b610137de80e35f7.svg";